import { getSchedule, getWaitLessonPage } from "@/services/chineseTeacher1v1";
import { formatArr } from "@/utils/util";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    schedule: {},
    courseList: [],
    teacherInfo: {}
  },
  actions: {
    async getTeacherSchedule({ dispatch, commit }, payload) {
      // 教师课表
      const content = await getSchedule(payload);
      commit("UPDATE_VALUE_STATES", { key: "schedule", data: content });
    },
    async setTeacherInfo({ dispatch, commit }, payload) {
      // 教师信息
      commit("UPDATE_VALUE_STATES", { key: "teacherInfo", data: payload });
    },
    async getWaitCourseList({ dispatch, commit }, payload) {
      const params = {
        startTime: moment(payload[0].date).format("YYYY-MM-DD"),
        endTime: moment(payload[payload.length - 1].date).format("YYYY-MM-DD")
      };
      const res = await getWaitLessonPage(params);
      const list = (res && res.list) || [];
      commit("UPDATE_VALUE_STATES", {
        key: "courseList",
        data: formatArr(payload, list)
      });
    }
  },
  mutations: {
    UPDATE_VALUE_STATES(state, payload) {
      const { key, data } = payload;
      state[key] = data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/chineseTeacher1v1.js